import { AriaRole, ReactNode } from "react";
import cx from "classnames";

import Typography, { TypographyProps } from "ds/components/Typography";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";

type SectionHeaderProps = {
  suffix?: ReactNode;
  titleSuffix?: ReactNode;
  titleHtmlFor?: string;
  titleTag?: TypographyProps["tag"];
  titleVariant?: TypographyProps["variant"];
  children: ReactNode;
  className?: string;
  align?: BoxProps["align"];
  prefix?: ReactNode;
  role?: AriaRole;
};

const SectionHeader = ({
  suffix,
  titleSuffix,
  titleHtmlFor,
  children,
  titleTag = "span",
  titleVariant,
  className,
  align = "center",
  prefix,
  role,
}: SectionHeaderProps) => (
  <Box justify="between" align="center" className={cx(styles.header, className)} role={role}>
    <Box grow="1" align={align} className={styles.titleWrapper}>
      {prefix}
      {typeof children === "string" ? (
        <Typography
          className={styles.title}
          variant={titleVariant}
          tag={titleTag}
          htmlFor={titleHtmlFor}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
      {titleSuffix}
    </Box>
    {suffix}
  </Box>
);

SectionHeader.displayName = "DS.Section.Header";

export default SectionHeader;
